import { useState, useEffect, useRef } from 'react';

/**
 * Custom hook for managing dropdown state and click-outside behavior
 * @param {Function} onOpen - Callback function to call when dropdown opens
 * @returns {Object} Dropdown state and methods
 */
export const useDropdown = (onOpen) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const toggleDropdown = () => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    
    // If opening the dropdown, call the onOpen callback
    if (newIsOpen && onOpen) {
      onOpen();
    }
  };

  const closeDropdown = () => setIsOpen(false);

  return {
    isOpen,
    dropdownRef,
    toggleDropdown,
    closeDropdown
  };
};
